// Purpose: Error Boundary — catches React render errors and shows fallback UI instead of white screen
// Caller: App.js (wraps entire app content)
// Dependencies: react
// Main Functions: componentDidCatch, render (fallback UI)
// Side Effects: Logs error to console

import React, { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'sans-serif',
          padding: '20px',
          textAlign: 'center',
        }}>
          <h1 style={{ color: '#e74c3c', marginBottom: '16px' }}>Terjadi Kesalahan</h1>
          <p style={{ color: '#555', marginBottom: '24px', maxWidth: '500px' }}>
            Maaf, terjadi kesalahan yang tidak terduga. Silakan muat ulang halaman.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px',
              fontSize: '16px',
              backgroundColor: '#e74c3c',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
            }}
          >
            Muat Ulang Halaman
          </button>
          <details style={{ marginTop: '24px', color: '#999', fontSize: '12px' }}>
            <summary>Detail Teknis</summary>
            <pre style={{ textAlign: 'left', marginTop: '8px' }}>
              {this.state.error && this.state.error.toString()}
            </pre>
          </details>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
